import { Button } from 'primereact/button';
import { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
import AddSubdistrict from '../admin/AddSubdistrict';
import '../../assests/css/common/responsive-ui.css';
import UserAddressService from '../../services/useraddress/useraddress.service';
import { PincodeAreaModel } from '../../models/cust-address/cust-address-model';

interface SearchPanelProps {
  reloadPage: (value: boolean) => void;
  setLoading: (loading: boolean) => void;
  setPageNumber: (pageNumber: number) => void;
  setPageSize: (pageSize: number) => void;
  setSubdistrictList: (subdistricts: PincodeAreaModel[]) => void;
  setTotalRecords: (total: number) => void;
  setSearchTerm: (searchTerm: string) => void;
  searchTerm: string;
}

const SubdistrictSearch: React.FC<SearchPanelProps> = ({
  reloadPage,
  setLoading,
  setPageNumber,
  setPageSize,
  setSubdistrictList,
  setTotalRecords,
  setSearchTerm,
  searchTerm,
}) => {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState<string>(searchTerm || '');
  const [isAddSubdistrict, setAddSubdistrict] = useState(false);

  const fetchData = async (searchText: string, pageNumber: number, pageSize: number) => {
    setLoading(true);
    try {
      const response = await UserAddressService.getAllSubDistrictsByFilter(searchText, pageNumber, pageSize);
      if (response) {
        setSubdistrictList(response.subDistricts);
        setTotalRecords(response.totalRecords);
        setSearchTerm(searchText);
      }
    } catch (error) {
      console.error('Error fetching subdistrict data:', error);
      setSubdistrictList([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    setPageNumber(1);
    setPageSize(10);
    fetchData(searchText, 1, 10);
  };

  const resetSearchFields = () => {
    setSearchText('');
    setPageNumber(1);
    setPageSize(10);
    fetchData('', 1, 10);
  };

  const hideAddAreaModal = () => {
    setAddSubdistrict(false);
    reloadPage(true);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchText !== searchTerm) {
        setPageNumber(1);
        fetchData(searchText, 1, 10);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  return (
    <div className="col-12">
      <div className="card border-noround p-2" style={{ minHeight: '3.5rem' }}>
        <div className="input-container font-bold text-white border-round" style={{ float: 'left', width: '18%' }}>
          <div className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onChange={(e) => setSearchText(e.target.value)}
              value={searchText}
              placeholder="Search Subdistrict"
              style={{ width: '100%' }}
            />
          </div>
        </div>

        <div className="buttons-container">
          <div className="filter-button font-bold text-white border-round ml-2" style={{ float: 'left', textAlign: 'right', width: '10%' }}>
            <Button
              className="text-black border-round"
              style={{ width: '100%', textAlign: 'center' }}
              onClick={resetSearchFields}
              severity="success"
              
              raised
            >
              Reset
            </Button>
          </div>

          <div className="add-button-container border-round font-bold ml-3 text-primary" style={{ textAlign: 'right' }}>
            <Button
              className="bg-green-700 border-round p-button p-button-text p-component text-center text-white"
              style={{ textAlign: 'center' }}
              onClick={() => setAddSubdistrict(true)}
              severity="secondary"
              text
              raised
            >
              Add
            </Button>
          </div>
        </div>

        {isAddSubdistrict && (
          <AddSubdistrict
            showAddUserModal={isAddSubdistrict}
            hideAddUserModal={hideAddAreaModal}
          />
        )}
      </div>
    </div>
  );
};

export default SubdistrictSearch;
